"use strict";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";
import {
    getUserLatestAchievementsComplete,
    ajaxError,
    getUserThingsToDoComplete,
    getUserMebershipComplete,
    getUserPointsTransactionsComplete,
    getUserGoalsComplete,
    getUserIncentiveHistoryComplete,
    getParticipantNotificationComplete,
    getNewsFeedComplete,
    readNotificationComplete,
    getParticipantNotificationRequest,
    getUserPointsBalanceComplete,
    getLatestTransactionComplete,
    userAccountLogUserLogStatusComplete
} from "../_actions";
import { userConstants, requestTypes } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const getUserAchievementsEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.USER_GET_LATEST_ACHIEVEMENTS_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/user/achievements",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getUserLatestAchievementsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

export const getUserThingsToDoEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.USER_GET_THINGS_TO_DO_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/user/things-to-do",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getUserThingsToDoComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

export const getUserMembershipEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.USER_MEMBERSHIP_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/user/user-membership",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getUserMebershipComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

export const getUserPointsTransactionsEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.USER_POINTS_TRANSACTIONS_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/pointbank/latest-transactions",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getUserPointsTransactionsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

export const getUserGoalsEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.USER_GOALS_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/user/user-goals",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getUserGoalsComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

export const getUserIncentiveHistoryEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.USER_INCENTIVE_HISTORY_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/user/user-incentive-history",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) =>
                        getUserIncentiveHistoryComplete(ajaxResponse.response),
                    ),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

export const getParticipantNotificationEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.GET_PARTICIPANT_NOTIFICATION_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/user/get-participant-notification",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) =>
                        getParticipantNotificationComplete(
                            ajaxResponse.response,
                        ),
                    ),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

export const getNewsFeedEpic = (actions$) => {
    return actions$.pipe(
        ofType(userConstants.GET_NEWS_FEED_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/user/news-feed",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getNewsFeedComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const readNotificationEpic = (actions$, state$, { dispatch }) => {
    return actions$.pipe(
        ofType(userConstants.READ_NOTIFICATION_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/user/read-notification/" + action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        dispatch(
                            getParticipantNotificationRequest({
                                id: state$.value.auth.userProfileDetails.id,
                            }),
                        );

                        return readNotificationComplete(ajaxResponse.response);
                    }),

                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getUserPointsBalanceEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.GET_USER_POINTS_BALANCE_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/pointbank/get-points-balance",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getUserPointsBalanceComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

    export const getLatestTransactionEpic = (actions$) =>
        actions$.pipe(
            ofType(userConstants.GET_LATEST_TRANSACTIONS_REQUEST),
            mergeMap((action) =>
                ajax
                    .get(
                        "/api/pointbank/get-latest-transactions",
                        getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                        map((ajaxResponse) => {
                            return getLatestTransactionComplete(
                                ajaxResponse.response,
                            );
                        }),
                        catchError((error) => of(ajaxError(error))),
                    ),
            ),
        );


export const userAccountLogUserLogStatusEpic = (actions$) =>
    actions$.pipe(
        ofType(userConstants.USER_ACCOUNT_LOG_USER_STATUS_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/user/log-user-login-status",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return userAccountLogUserLogStatusComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
